import { cookie } from 'cookie_js'
import API from 'utils/API'

export const logout = () => {
  const token = cookie.get('learn_auth_token')

  API.post(API.endPoints().auth.logout, { token }, {}).then(() => {
    cookie.remove('learn_auth_token')
    window.location.href = '/'
  })
}
